<!--
 * @Author:
 * @LastEditTime: 2023-07-28
 * @Description: 定时隐患排查
-->
<template>
  <el-card class="h-full relative">
    <el-tabs v-model="activeName">
      <el-tab-pane label="设备设施类" name="equip">
        <timing-equip-table v-if="activeName === 'equip'"></timing-equip-table>
      </el-tab-pane>
      <el-tab-pane label="作业活动类" name="job">
        <timing-job-table v-if="activeName === 'job'"></timing-job-table>
      </el-tab-pane>
      <el-tab-pane label="基础管理类" name="base">
        <timing-base-table v-if="activeName === 'base'"></timing-base-table>
      </el-tab-pane>
    </el-tabs>
  </el-card>
</template>

<script>
import TimingEquipTable from '../components/TimingPlanTable/TimingEquipTable'
import TimingJobTable from '../components/TimingPlanTable/TimingJobTable'
import TimingBaseTable from '../components/TimingPlanTable/TimingBaseTable'

export default {
  name: 'trouble-shoot-task-plan',
  components: {
    TimingEquipTable,
    TimingJobTable,
    TimingBaseTable,
  },
  data() {
    return {
      activeName: 'equip',
    }
  },
}
</script>

<style scoped lang="scss">
::v-deep .el-card__body {
  height: 100%;
}
::v-deep .el-tabs {
  height: 100%;
}
::v-deep .el-tabs__content {
  height: calc(100% - 54px) !important;
  position: inherit;
  .el-tab-pane {
    height: 100%;
  }
}
</style>
